import styled from "@emotion/styled";
import { Box, Button, Stack, Typography } from "@mui/material";

export const ItemWrapper = styled(Stack)(() => ({
  padding: "24px 20px 34px 20px",
  borderRadius: "20px",
  height: "100%",
  minWidth: "344px",
  maxWidth: "410px",
  border: "1px #EAECF0 solid",
  backgroundColor: "#ffff",
  alignItems: "center",
  textAlign: "center",
  gap: "16px",
  boxSizing: "border-box",
  cursor: "pointer",
  position: "relative",
}));

export const ChartWrapper = styled(Box)(() => ({
  width: "200px",
  height: "200px",
  position: "relative",
}));

export const ChartText = styled(Typography)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: "30px",
}));

export const InspectBtn = styled(Button)(() => ({
  position: "absolute",
  width: "calc(100% - 40px)",
  height: "44px",
  bottom: "-22px",

  "&.Mui-disabled": {
    backgroundColor: "#dddddd",
  },
}));
